import React from "react";
import uniqueId from "lodash/uniqueId";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormCheck from "react-bootstrap/FormCheck";
import Button from "react-bootstrap/Button";
const defaultCols = {
    xs: 12,
    sm: 6,
};
class SelectModal extends React.Component {
    constructor(props) {
        super(props);
        this.onShow = () => {
            this.setState({
                values: (this.props.values || []).slice(),
            });
            const fn = this.props.onShow;
            if (fn) {
                fn();
            }
        };
        this.onHide = () => {
            const fn = this.props.onHide;
            if (fn) {
                fn();
            }
        };
        this.onChange = (value, checked) => {
            let values = this.state.values;
            const index = values.indexOf(value);
            if (checked) {
                if (this.props.multiple) {
                    if (index < 0) {
                        values.push(value);
                    }
                }
                else {
                    values = value !== '' ? [value] : [];
                }
            }
            else {
                if (index >= 0) {
                    values.splice(index, 1);
                }
            }
            values.sort();
            this.setState({
                values: values,
            });
        };
        this.onSubmit = () => {
            const props = this.props, fn = props.onSubmit;
            if (fn) {
                fn(this.state.values);
            }
            this.onHide();
        };
        this.state = {
            show: props.show,
            name: uniqueId((props.name || 'select') + "-"),
            values: [],
        };
    }
    render() {
        const props = this.props, state = this.state, cols = props.cols || defaultCols, type = props.multiple ? 'checkbox' : 'radio';
        return (React.createElement(Modal, Object.assign({ show: props.show, onShow: this.onShow, onHide: this.onHide, dialogClassName: "select-modal" }, props.modal, { "data-id": state.name, "data-name": props.name }),
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null,
                    React.createElement("span", null, props.title),
                    " \u3092\u9078\u629E")),
            React.createElement(Modal.Body, null,
                props.items.length > 0 ? (React.createElement(Row, null,
                    !props.multiple && (props.defaultLabel || '').length > 0 && (React.createElement(Col, Object.assign({}, cols),
                        React.createElement(FormCheck, { id: `select-${this.state.name}`, type: type, name: this.state.name, value: "", label: props.defaultLabel || '', defaultChecked: !props.values || props.values.length == 0, onChange: e => this.onChange('', e.target.checked) }))),
                    props.items.map((v, i) => (React.createElement(Col, Object.assign({ key: i }, cols),
                        React.createElement(FormCheck, { id: `select-${state.name}-${i}`, type: type, name: state.name, value: v.slug, label: v.name, defaultChecked: props.values && props.values.indexOf(v.slug) >= 0, onChange: e => this.onChange(v.slug, e.target.checked) })))))) : (React.createElement(React.Fragment, null, "\u30C7\u30FC\u30BF\u304C\u306A\u3044")),
                props.comment && (React.createElement(Row, null,
                    React.createElement(Col, null, props.comment)))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { type: "button", variant: `outline-secondary`, onClick: props.onHide }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                React.createElement(Button, { type: "button", variant: `primary`, onClick: this.onSubmit }, "\u9078\u629E\u3059\u308B"))));
    }
}
export default SelectModal;
